import { IonRouterOutlet } from '@ionic/react';
import React, { useContext, useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router';
import { UserContext } from '../contexts/UserContext';
import { analyticsHelper, consoleHelper } from '../helpers';
import {
  CharacterPage,
  ContentPage,
  ConversationPage,
  HomePage,
  LoginPage,
  LogoutPage,
  ReaderPage,
} from '../pages';
import { CustomerLayout, ExpertLayout } from './layout';
import { Menu } from './menu/Menu';

export const Routes = () => {
  const { isCustomer } = useContext(UserContext);
  const location = useLocation();

  useEffect(() => {
    analyticsHelper.setScreenName(location.pathname, 'Routes');
    consoleHelper.log('Location changed: ' + location.pathname);
  }, [location]);

  return (
    <div>
      {isCustomer ? <Menu /> : null}
      <IonRouterOutlet id="main">
        <Route path="/expert" component={ExpertLayout} />
        <Route path="/customer" component={CustomerLayout} />
        <Route
          path="/conversation/:idExpert/:idCustomer"
          component={ConversationPage}
        />
        <Route path="/login" component={LoginPage} />
        <Route path="/logout" component={LogoutPage} />
        <Route path="/reader/:id" component={ReaderPage} />
        <Route path="/home" component={HomePage} />
        <Route path="/content/:slug?" component={ContentPage} />
        <Route path="/character/:code" component={CharacterPage} />
        <Redirect exact from="/" to="/home" />
      </IonRouterOutlet>
    </div>
  );
};
